<template src="./RenunciaList.html"></template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import { Breadcrumb, BreadcrumbItem, Button, Dialog } from "element-ui";
import { utils } from "@/utils";
import { NotifyMixin } from "@/mixins/NotifyMixin";
import { ExportToFileMixin } from "@/mixins/exportToFile";
// import moment from "moment-timezone";
import { RouterMixin } from "@/mixins/routerMixin";
import { BrotliMixin } from "@/mixins/BrotliMixin";
// import csvToJson from "convert-csv-to-json";
import RenunciaTable from "@/components/PartidoPolitico/Renuncia/RenunciaTable/RenunciaTable";
import ExportToFile from "@/components/Shared/ExportToFile/ExportToFile";
import { requestRenunciaPPMixin } from "@/api/partidoPolitico/renunciaPPApi";
import { FileDownloadMixin } from "@/mixins/FileDownload";

export default {
  name: "RenunciaList",
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    ExportToFile,
    RenunciaTable,
  },
  mixins: [
    NotifyMixin,
    ScreenSizeMixin,
    ExportToFileMixin,
    RouterMixin,
    BrotliMixin,
    requestRenunciaPPMixin,
    FileDownloadMixin,
  ],
  data: () => ({
    loading: false,
    errored: false,
    inRoute: false,
    tableData: [],
    dlgExportToFile: false,
    idRenuncia: "",
    header: [
      "Solicitud de renuncia",
      "Rut",
      "Nombres",
      "Apellido Paterno",
      "Apellido Materno",
      "Fecha Nacimiento",
      "Teléfono Móvil",
      "Teléfono Fijo",
      "Región",
      "Comuna",
      "Domicilio",
      "Fecha última acción",
      "Estado de la Solicitud",
    ],
    filter: [
      "id",
      "run",
      "nombres",
      "paterno",
      "materno",
      "fechanacimiento",
      "telefonomovil",
      "telefonofijo",
      "region",
      "comuna",
      "domicilio",
      "fechacompleta",
      "estado",
    ],
    disabled: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
    ],
  }),
  computed: {
    fieldsToExport: function () {
      const list = this.header.map((h, i) => ({
        name: h,
        key: this.filter[i],
        disabled: this.disabled[i],
      }));
      this.$log.debug(list);
      return list;
    },
  },
  filters: {
    capitalize: function (value) {
      return utils.capitalize(value);
    },
  },
  beforeMount() {
    if (this.$route.name === "renuncia-list") {
      this.inRoute = true;
    }
  },
  methods: {
    viewRenuncia(id) {
      this.$log.debug("table viewRenuncia", id);

      this.idRenuncia = id;
      this.navigate({ name: "renuncia-pp-id", params: { id: id } });
    },
    exportToFile(querySearch = "", dateFilter = []) {
      this.$log.debug("exportToFile", querySearch, dateFilter);
      this.querySearch = querySearch;
      this.dateFilter = dateFilter;

      this.dlgExportToFile = true;
    },
    closeDlgExport() {
      this.dlgExportToFile = false;
    },
    async exportToExcel(checkList, fields) {
      this.$log.debug("exportToExcel", checkList, fields);
      const listField = this.getListField(checkList, fields);
      const data = await this.listaRenuncia({
        fields: listField,
        format: "xls",
      });
      /* if (!this.errored) {
        const date = moment(new Date()).format('YYYYMMDDhhmmss')
        const filename = `renuncias-${date}`
        this.exportExcel(data, checkList, fields, filename)
      }*/
    },
    async exportToPdf(checkList, fields) {
      this.$log.debug("exportToPdf", checkList, fields);
      const listField = this.getListField(checkList, fields);
      const data = await this.listaRenuncia({
        fields: listField,
        format: "pdf",
      });
      /*if (!this.errored) {
        const date = moment(new Date()).format('YYYYMMDDhhmmss')
        const filename = `renuncias-${date}`
        const title = 'Lista de Renuncias'
        this.exportPdf(data, checkList, fields, filename, title)
      }*/
    },
    listaRenuncia({
      pageAll = true,
      search = this.querySearch,
      dateRange = this.dateFilter,
      fields = fields,
      format = "csv",
      compress = true,
    } = {}) {
      this.loading = true;
      const pagingQuery = {
        pageAll: pageAll,
        search: search,
        dateRange: dateRange,
        fields: fields,
        format: format,
        compress: compress,
      };

      const loading = this.getLoading();

      return this.getListaRenuncia(pagingQuery)
        .then((response) => {
          this.$log.debug("getListaRenuncia", response.data.statusCode);

          if (response.data.statusCode === 200) {
            this.$log.debug(response.data.datos);

            this.downloadFileDocument(response.data.datos);

            /*const data = this.decompress(response.data.datos)
            this.$log.debug(data)
            let dataformat = data
            if (pagingQuery.format === 'csv') {
              dataformat = csvToJson
                .fieldDelimiter(';')
                .csvStringToJson(data)
            }

            const datasource = dataformat.map(row => {
              row.run = utils.rutFilter(row.run)
              return row
            })
            this.$log.debug(datasource)
            this.errored = false

            return datasource*/
          } else {
            this.errored = true;
            this.showError("Ocurrió un error inesperado al cargar los datos");
          }
          return [];
        })
        .catch((err) => {
          this.$log.fatal("getListaRenuncia", err, err.response, err.request);
          this.errored = true;
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          this.loading = false;
          loading.close();
        });
    },
  },
};
</script>

